import React from "react";

const FormInputs = (props) => {
  return (
    <form
      className="form-inputs-postura"
      onSubmit={(event) => {
        event.preventDefault();
        props.generateReport();
      }}
    >
      <div className="row lay">
        <div className="col-md-6">
          <div className="form-group mt-3">
            <label>Metodologia</label>
            <select
              className="form-control form-control-sm"
              value={props.inputs.metodology}
              onChange={(event) => props.selectHandler(-1, "metodology", event)}
            >
              <option value="">Selecione a Metodologia</option>
              <option value="average">Indivíduo Médio</option>
              <option value="maxProfit">Máximo Retorno Econômico</option>
              <option value="population">População</option>
            </select>
          </div>
        </div>
        {props.inputs.metodology === "population" ? (
          <div className="col-md-6">
            <div className="form-group mt-3">
              <label>Percentual(%)</label>
              <input
                type="number"
                className="form-control form-control-sm"
                value={props.inputs.populationRequirement}
                onChange={(event) =>
                  props.inputHandler(-1, "populationRequirement", event)
                }
                placeholder="% População"
              />
            </div>
          </div>
        ) : null}
        {props.inputs.metodology === "maxProfit" ? (
          <div className="col-md-6">
            <div className="form-group mt-3 form-inputs-postura__egg-price">
              <span>Preço/caixa 30dz:</span>
              <input
                type="number"
                className="form-control form-control-sm"
                value={props.inputs.small}
                onChange={(event) => props.inputHandler(-1, "small", event)}
                placeholder="Pequeno"
              />
              <input
                type="number"
                className="form-control form-control-sm"
                value={props.inputs.medium}
                onChange={(event) => props.inputHandler(-1, "medium", event)}
                placeholder="Médio"
              />
              <input
                type="number"
                className="form-control form-control-sm"
                value={props.inputs.large}
                onChange={(event) => props.inputHandler(-1, "large", event)}
                placeholder="Grande"
              />
            </div>
          </div>
        ) : null}
      </div>
      <table className="table">
        <thead className="thead-dark form-inputs-postura__header">
          <tr>
            <th
              className="col form-inputs-postura__header--fixed text-center"
              colSpan="3"
            >
              Programa de dieta
            </th>
          </tr>
          <tr>
            <th className="col form-inputs-postura__header--fixed">
              Início (Semana)
            </th>
            <th className="col form-inputs-postura__header--fixed">
              Fim (Semana)
            </th>
            <th className="col form-inputs-postura__header--fixed">
              Consumo (g/dia)
            </th>
            <th className="col form-inputs-postura__header--fixed">
              Temperatura (ºC)
            </th>
            <th className="col form-inputs-postura__header--fixed">
              Peso Vivo (kg)
            </th>
            <th className="col form-inputs-postura__header--fixed">
              Postura (%)
            </th>
            <th className="col form-inputs-postura__header--fixed">
              Massa de ovo (g/ave/dia)
            </th>
          </tr>
        </thead>
        <tbody>
          {props.inputs.feedProgram.map((input, indexRow) => (
            <tr key={`row${indexRow}`}>
              {Object.keys(input).map((key, indexColumn) => (
                <td key={`column${indexColumn}`}>
                  <input
                    type="number"
                    className="form-control"
                    placeholder={input[key].label}
                    value={input[key].value}
                    onChange={(event) =>
                      props.inputHandler(indexRow, key, event, "feedProgram")
                    }
                  />
                </td>
              ))}
            </tr>
          ))}
          <tr>
            <td colSpan="8">
              <div className="form-inputs-postura__footer d-flex justify-content-end">
                {props.inputs.feedProgram.length > 1 ? (
                  <button
                    type="button"
                    className="btn btn-danger btn-sm mr-1"
                    onClick={() => props.removeLine("feedProgram")}
                  >
                    Remover linha
                  </button>
                ) : null}
                <button
                  type="button"
                  className="btn btn-info btn-sm"
                  onClick={props.addLineFeedProgram}
                >
                  Adicionar Linha
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div className="row">
        <div className="col-md-12 text-center">
          <button type="submit" className="btn btn-primary btn-sm ">
            Gerar Relatório
          </button>
        </div>
      </div>
    </form>
  );
};

export default FormInputs;
